export default __webpack_public_path__ + "static/media/search-icon.b038df2e.svg";